import { BillingCycle } from "components/shareable/UpgradeToProModal/utils";
import { PlanType } from "modules/Const";
import { AffiliateDetails, CurrentBrand, UserData } from "modules/Types";

export const getPartnerDiscount: {
  [key: string]: AffiliateDetails;
} = {
  UM: {
    discountAmount: 0.75,
    partnerId: "UM",
    partnerName: "United Masters",
    cookieExpirationFromSignup: 90,
    startDate: "2023-09-26",
    shownPlansOnSignup: [PlanType.LITE, PlanType.PRO],
    defaultRecurringIntervalOnSignup: BillingCycle.MONTHLY,
    planDiscounts: {
      [PlanType.PRO]: {
        [BillingCycle.MONTHLY]: 0.75,
        [BillingCycle.ANNUAL]: 0.75,
      },
    },
  },

  Audiomack: {
    discountAmount: 0.75,
    partnerId: "Audiomack",
    partnerName: "Audiomack",
    cookieExpirationFromSignup: 90,
    startDate: "2023-11-14",
    shownPlansOnSignup: [PlanType.LITE],
    defaultRecurringIntervalOnSignup: BillingCycle.ANNUAL,
    planDiscounts: {
      [PlanType.LITE]: {
        [BillingCycle.ANNUAL]: 0.75,
      },
      [PlanType.PRO]: {
        [BillingCycle.MONTHLY]: 0.75,
        [BillingCycle.ANNUAL]: 0.75,
      },
    },
  },

  "Daily Playlists": {
    discountAmount: 0.75,
    partnerId: "Daily Playlists",
    partnerName: "Daily Playlists",
    cookieExpirationFromSignup: 90,
    startDate: "2024-10-29",
    shownPlansOnSignup: [PlanType.LITE],
    defaultRecurringIntervalOnSignup: BillingCycle.ANNUAL,
    planDiscounts: {
      [PlanType.PRO]: {
        [BillingCycle.MONTHLY]: 0.75,
        [BillingCycle.ANNUAL]: 0.75,
      },
    },
  },

  CDBaby: {
    discountAmount: 0.75,
    partnerId: "CDBaby",
    partnerName: "CDBaby",
    cookieExpirationFromSignup: 90,
    startDate: "2023-12-10",
    shownPlansOnSignup: [PlanType.LITE, PlanType.PRO],
    defaultRecurringIntervalOnSignup: BillingCycle.MONTHLY,
    planDiscounts: {
      [PlanType.PRO]: {
        [BillingCycle.MONTHLY]: 0.75,
        [BillingCycle.ANNUAL]: 0.75,
      },
    },
  },
  Downtown: {
    discountAmount: 0.75,
    partnerId: "Downtown",
    partnerName: "Downtown",
    cookieExpirationFromSignup: 90,
    startDate: "2024-06-03",
    shownPlansOnSignup: [PlanType.LITE],
    defaultRecurringIntervalOnSignup: BillingCycle.ANNUAL,
    planDiscounts: {
      [PlanType.PRO]: {
        [BillingCycle.MONTHLY]: 0.75,
        [BillingCycle.ANNUAL]: 0.75,
      },
    },
  },

  SoundCloud: {
    discountAmount: 0.75,
    partnerId: "SoundCloud",
    partnerName: "SoundCloud",
    cookieExpirationFromSignup: 90,
    startDate: "2025-02-05",
    shownPlansOnSignup: [PlanType.LITE],
    defaultRecurringIntervalOnSignup: BillingCycle.ANNUAL,
    planDiscounts: {
      [PlanType.LITE]: {
        [BillingCycle.ANNUAL]: 0.75,
      },
      [PlanType.PRO]: {
        [BillingCycle.MONTHLY]: 0.75,
        [BillingCycle.ANNUAL]: 0.75,
      },
    },
  },


  Groover: {
    discountAmount: 0.75,
    partnerId: "Groover",
    partnerName: "Groover",
    cookieExpirationFromSignup: 90,
    startDate: "2025-06-18",
    shownPlansOnSignup: [PlanType.LITE],
    defaultRecurringIntervalOnSignup: BillingCycle.ANNUAL,
    planDiscounts: {
      [PlanType.LITE]: {
        [BillingCycle.ANNUAL]: 0.75,
      },
      [PlanType.PRO]: {
        [BillingCycle.MONTHLY]: 0.75,
        [BillingCycle.ANNUAL]: 0.75,
      },
    },
  },


  Symphonic: {
    discountAmount: 0.75,
    partnerId: "Symphonic",
    partnerName: "Symphonic",
    cookieExpirationFromSignup: 90,
    startDate: "2025-02-05",
    shownPlansOnSignup: [PlanType.LITE],
    defaultRecurringIntervalOnSignup: BillingCycle.ANNUAL,
    planDiscounts: {
      [PlanType.LITE]: {
        [BillingCycle.ANNUAL]: 0.75,
      },
      [PlanType.PRO]: {
        [BillingCycle.MONTHLY]: 0.75,
        [BillingCycle.ANNUAL]: 0.75,
      },
    },
  },

  EngineEars: {
    discountAmount: 0.75,
    partnerId: "EngineEars",
    partnerName: "EngineEars",
    cookieExpirationFromSignup: 90,
    startDate: "2025-03-05",
    shownPlansOnSignup: [PlanType.LITE],
    defaultRecurringIntervalOnSignup: BillingCycle.ANNUAL,
    planDiscounts: {
      [PlanType.LITE]: {
        [BillingCycle.ANNUAL]: 0.75,
      },
      [PlanType.PRO]: {
        [BillingCycle.MONTHLY]: 0.75,
        [BillingCycle.ANNUAL]: 0.75,
      },
    },
  },
};
